import { rateLimitStatusesQuery } from '#pplx/frontend/apps/ask/user-settings/rateLimitStatusesQuery.js';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
/**
 * This hook refreshes the rate limit data for the current user.
 */
export function useRefreshRateLimits() {
    const queryClient = useQueryClient();
    return useCallback(() => {
        queryClient.invalidateQueries({
            queryKey: rateLimitStatusesQuery.getKey({}),
        });
    }, [queryClient]);
}
//# sourceMappingURL=useRefreshRateLimits.js.map